import { Divider, Dropdown, message } from 'antd';
import { observer } from 'mobx-react-lite';
import { useMainContext } from '../../../hooks/useMainContext';
import { useState } from 'react';
import { IoIosArrowDown, IoIosArrowUp, IoMdAdd } from 'react-icons/io';
import Button from '../../Globle/Button';

const PageList = observer(() => {
    const {
        viewManager,
        closetManager,
        matrixManager,
        uiManager,
        drawingManager,
    } = useMainContext();
    const [isOpen, setIsOpen] = useState(false);
    const handleSelectPage = async (page) => {
        if (!page) return;
        closetManager.setIsLoading(true);
        viewManager.setActivePageNo(page.pageNum);
        await viewManager.bringChangesToClosetAccordingToSelectedPages();
        await closetManager.setSelectedPageNo(page.pageNum);
        await closetManager.fitToScreen();
        viewManager.updatePossibleClosets();
        closetManager.setIsLoading(false);
        setIsOpen(false);
    };
    const handleOpenModel = () => {
        drawingManager.handleDeselectAll();
        if (viewManager.fullPdf) {
            viewManager.setHasUserFinalized(false);
            // viewManager.setSelectedMenu(1);
            const pages = [...viewManager.selectedPages];
            uiManager.setPrevSelectedPages(pages);
            uiManager.setIsPdfUploadModel(true);
            setIsOpen(false);
        } else {
            message.error('Full pdf is still not arrived');
        }
    };
    const renderMenu = () => {
        return (
            <div className="p-[8px] bg-theme-white w-[200px] shadow-card rounded-[8px]">
                <div className="flex flex-col gap-[4px] max-h-[164px] pr-[4px] overflow-y-auto">
                    {viewManager?.selectedPages &&
                        [...viewManager.selectedPages]
                            .sort(
                                (a, b) => Number(a.pageNum) - Number(b.pageNum),
                            )
                            .map((page, index) => {
                                const selected =
                                    Number(page.pageNum) ===
                                        Number(closetManager.selectedPageNo) ||
                                    matrixManager.selectedPageNo ===
                                        page.pageNum;
                                page.pageNum === closetManager.selectedPageNo;
                                return (
                                    <div
                                        onClick={() => handleSelectPage(page)}
                                        key={index}
                                        className={`${selected ? 'bg-theme-header-bg font-[700]' : 'hover:bg-theme-button-bg font-[400]'} rounded-[8px] p-[8px] cursor-pointer transition-all duration-300 ease-in-out`}>
                                        {page.name || 'Page ' + page.pageNum}
                                    </div>
                                );
                            })}
                </div>
                <Divider className="!mt-[8px] !mb-[8px]  !border-theme-border" />
                <Button
                    disabled={!viewManager.superAdmin}
                    icon={IoMdAdd}
                    iconClass="!text-[20px] !ml-0 !mr-1 mb-[3px]"
                    onClick={() => {
                        handleOpenModel();
                    }}
                    label={'Add Page'}
                    className="!w-full !h-[32px] !bg-transparent !rounded-[8px] text-theme-black hover:!bg-theme-orange hover:text-white !pl-[4px]"
                />
            </div>
        );
    };
    return (
        <Dropdown
            open={isOpen}
            onOpenChange={setIsOpen}
            dropdownRender={renderMenu}
            trigger={['click']}>
            <div className="flex items-center gap-[8px] cursor-pointer">
                <span
                    className={`text-[16px] font-favorit ${isOpen ? 'font-[700]' : ''}`}>
                    Pages
                </span>
                <span
                    className={`inline-block w-[24px] h-[24px] text-[12px] pt-[2px] pr-[2px] rounded-full ${isOpen ? 'bg-theme-orange' : 'bg-theme-stroke'} text-theme-white flex items-center justify-center`}>
                    {viewManager?.selectedPages?.length}
                </span>
                {isOpen ? (
                    <IoIosArrowUp size={20} />
                ) : (
                    <IoIosArrowDown size={20} />
                )}
            </div>
        </Dropdown>
    );
});

export default PageList;
